/* Peak Core — product card media carousel
   Desktop: arrows on hover · Mobile: auto-slide + swipe */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {};

  function fetchImages(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? p.images.slice(0, 3) : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function sized(src, w) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function initCard(wrapper) {
    if (wrapper.dataset.luxeCc) return;
    var link = wrapper.querySelector('a[href*="/products/"]');
    var media = wrapper.querySelector('.card__media .media') || wrapper.querySelector('.card__media');
    if (!link || !media) return;
    var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    wrapper.dataset.luxeCc = '1';

    fetchImages(m[1]).then(function (imgs) {
      if (!imgs || imgs.length < 2) return;
      var baseImg = media.querySelector('img');
      if (!baseImg) return;
      media.classList.remove('media--hover-effect');
      media.querySelectorAll('img').forEach(function (im, i) { if (i > 0) im.remove(); });

      baseImg.classList.add('luxe-cc__slide', 'is-active');
      var slides = [baseImg];
      for (var i = 1; i < imgs.length; i++) {
        var clone = baseImg.cloneNode(false);
        clone.classList.remove('is-active');
        clone.classList.add('luxe-cc__slide', 'luxe-cc__extra');
        clone.removeAttribute('srcset');
        clone.removeAttribute('sizes');
        clone.src = sized(imgs[i], 700);
        clone.loading = 'lazy';
        media.appendChild(clone);
        slides.push(clone);
      }

      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'luxe-cc__dots';
      var dots = slides.map(function (_, i) {
        var d = document.createElement('span');
        d.className = 'luxe-cc__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
        return d;
      });
      media.appendChild(dotsWrap);

      var idx = 0, timer = null, holdUntil = 0;
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }

      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'luxe-cc__nav luxe-cc__nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          holdUntil = Date.now() + 8000;
          show(dir === 'prev' ? idx - 1 : idx + 1);
        });
        media.appendChild(b);
      });

      var sx = null;
      media.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        sx = null;
        if (Math.abs(dx) > 35) {
          holdUntil = Date.now() + 8000;
          show(dx < 0 ? idx + 1 : idx - 1);
        }
      }, { passive: true });

      if (!reduced && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && window.matchMedia('(max-width: 749px)').matches) {
              if (!timer) timer = setInterval(function () { if (Date.now() > holdUntil) show(idx + 1); }, 4000);
            } else if (timer) {
              clearInterval(timer);
              timer = null;
            }
          });
        }, { threshold: 0.4 });
        io.observe(media);
      }
    });
  }

  function scan() {
    document.querySelectorAll('.card-wrapper').forEach(initCard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
